import { Controller } from '@hotwired/stimulus'
import TomSelect from '@tabler/core/dist/libs/tom-select/dist/js/tom-select.complete.min.js'

export default class extends Controller {
  static values = {
    options: Object,
    placeholder: String,
  }

  connect() {
    this.tomSelectInstance = new TomSelect(this.element, {
      plugins: ['remove_button'],
    })
    this.tomSelectInstance.settings.placeholder = this.placeholderValue
    this.tomSelectInstance.inputState()
  }

  disconnect() {
    this.tomSelectInstance.destroy()
  }
}
